export default "__VITE_ASSET__C03MYHis__"